import { loadQuery } from 'react-relay';
import RelayEnvironment from 'lib/utils/relay';

import { authValidateForgotUserPasswordQuery } from 'services/auth/__generated__/authValidateForgotUserPasswordQuery.graphql';
import { AUTH_VALIDATE_FORGOT_USER_PASSWORD_QUERY } from 'services/auth/auth.relay.services';

interface Props {
  token: string;
}

export const ResetPasswordPreloadData = ({ token }: Props) => {
  return {
    validateForgotPasswordQueryRef: loadQuery<authValidateForgotUserPasswordQuery>(
      RelayEnvironment,
      AUTH_VALIDATE_FORGOT_USER_PASSWORD_QUERY,
      {
        input: { token },
        skip: !token,
      },
      { fetchPolicy: 'network-only' },
    ),
    token,
  };
};

export type ResetPasswordTypePreloadDataType = ReturnType<typeof ResetPasswordPreloadData>;
